import { clsx } from "clsx";
import { useState } from "react";
import { Grid } from "../../../../../components";
import { usePagination } from "../../../../../hooks";
import { sortGridByColumn } from "../../../../../utils";
import {
  RLCSYaraEntry,
  RLCSYaraMatch,
  SortParams
} from "../../../@types/rldynamicanalysis/yara";
import styles from "./rlcloudsandboxyara.module.scss";
import { RLCloudSandboxYaraMatchSchema } from "./RLCloudSandboxYaraMatchSchema";

const RLCloudSandboxYaraMatches = (rowData: RLCSYaraEntry) => {
  const matchData: RLCSYaraMatch[] = rowData.matches ?? [];
  const { data, currentPageData, updatePageData } = usePagination(matchData, {
    pageSize: 10
  });

  const [sort, setSort] = useState({
    field: "default",
    direction: "asc"
  });

  const handlePageChange = (newPage: number, newPageSize?: number): void => {
    updatePageData({ newPage, newPageSize });
  };

  const handleSortChange = (sortParams: SortParams) => {
    const { field, direction } = sort;
    if (sortParams.direction === direction && sortParams.field === field)
      return;
    setSort(sortParams);
    sortGridByColumn(data, sortParams);
  };

  return matchData.length > 0 ? (
    <div className={styles.rlcs_yara_pad_left}>
      <Grid
        data={data}
        schema={RLCloudSandboxYaraMatchSchema}
        totalResults={matchData.length}
        page={currentPageData.page}
        pageSize={currentPageData.pageSize}
        onPageChange={handlePageChange}
        numPages={currentPageData.numPages}
        showPageNumbers
        sort={sort}
        onSortChange={handleSortChange}
      />
    </div>
  ) : (
    <div className={clsx(styles.rlcs_yara_pad_left, "bold")}>
      No match data available for this rule.
    </div>
  );
};

export default RLCloudSandboxYaraMatches;
